import { z } from 'zod';
import { FormationCreatedFrom } from '../enums/formation-created-from';

export const QuarkFormations = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  level_id: z.string().uuid().nullable(),
  name: z.string(),
  start_at: z.string().nullable(),
  end_at: z.string().nullable(),
  end_year: z.number().nullable(),
  establishment: z.string().nullable(),
  place: z.string().nullable(),
  on_going: z.boolean().nullable(),
  graduate: z.boolean().nullable(),
  abroad: z.boolean().nullable(),
  description: z.string().nullable(),
  rank: z.number().nullable(),
  is_visible: z.boolean(),
  is_wish: z.boolean(),
  favorite: z.number().int().nullable(),
  created_from: FormationCreatedFrom,
  created_at: z.string(),
  updated_at: z.string(),
});

export type QuarkFormationsT = z.infer<typeof QuarkFormations>;

export const QuarkFormationsInsert = QuarkFormations.partial();

export type QuarkFormationsInsertT = z.infer<typeof QuarkFormationsInsert>;

export const QuarkFormationsUpdate = QuarkFormations.omit({
  id: true,
  created_at: true,
}).partial();

export type QuarkFormationsUpdateT = z.infer<typeof QuarkFormationsUpdate>;
